import React from 'react';
import EditProductModal from './EditProductModal';
import styles from './edit-product-modal.scss';
import OmniForm from 'jd-library/OmniForm';
import withPortal from 'jd-library/withPortal';
import historyHandler from 'jd-library/historyHandler';

const EditProductModalWrapper = props => {

	let inputObj = [];
	const initialValues = {};

	props.inputObj.forEach(item => {
		initialValues[item.key] = item.value
	});

	const useFormData = OmniForm.useForm({
		initialValues : initialValues
	});

	const {
		values,
		errors,
		handleFocus,
		handleChange,
		setFieldError
	} = useFormData;

	props.inputObj.forEach(item => {
			inputObj.push(
				{
					label: item.label,
					key: item.key,
					holderClass: `${styles['edit-product-row']} ${styles[item.class]} ${styles[props.holderClass]}`,
					errorMessage: errors[item.key],
					warning: item.key == 'sellingPrice' && errors[item.key] ? true : false,
					input: {
						value: values[item.key] || '',
						type: item.type,
						name: item.name,
						onChange: e => onChange(e, item.key),
						onKeyDown : e => handleKeyDown(e, item.key),
						onFocus: item.key == 'sellingPrice' ? "" : e => handleFocus(e, item.key),
						autoFocus: item.key == 'mrp' || item.key == 'productName' || item.key == 'fileName' ? true : false
					}
				}
			);
	});

	const handleKeyDown = (event) => {
		if(event.which == 13){
			onAddEditModalBtnClick();
		}
	}

	const validateCurrency = (e) =>{
		var moneyRegex = /^[\d]{0,10}(\.[\d]{0,2})?$/;
		if(moneyRegex.test(e.target.value)){
			return true;
		}else{
			return false;
		}	
	}

	const onChange = (event, key) => {
		if(props.type == 'price'){
			if(!(validateCurrency(event))){
				return;
			}
			handleChange(event, key);
			if(key == 'mrp'){
				inputObj[0].input.value = event.target.value;
			}else if(key == 'sellingPrice'){
                inputObj[1].input.value = event.target.value;
			}
			if(parseInt(inputObj[0].input.value) < parseInt(inputObj[1].input.value)){
				setFieldError({[inputObj[1].key]: 'Higher than MRP'});
			}
			if(parseInt(inputObj[0].input.value) >= parseInt(inputObj[1].input.value)){
				setFieldError({[inputObj[1].key]: ''});
			}
		}else{
			handleChange(event, key);
		}
	}

	const onModalClose = () => {
        props.onModalClose();
	};

	const validateInput = () => {
        let isValid = true;

		if(props.customValidation){
			let validateModalDataCB = function({isError, errorMsg, inputField}){
                 if(isError){
					setFieldError({[inputField.key]: errorMsg});
					isValid = false;
				 }
			};
			props.validateModalData(inputObj, validateModalDataCB);
		}else{
			if(inputObj.length > 1){
				// inputObj.modalType = 'productPrice';
				// let mrpField = inputObj[0];
				// let spField = inputObj[1];
				// if(parseInt(spField.input.value) > parseInt(mrpField.input.value)){
				// 	setFieldError({[spField.key]: 'Higher than MRP'});
				//    	isValid = false;
				// }
			  
			}else{	
			   let inputField = inputObj[0];
			   inputObj.modalType = 'productName';
			   if(!inputField.input.value){
				   setFieldError({[inputField.key]: 'Please Enter Product Name'});
				   isValid = false;
			   }else if(inputField.input.value.length < 3){
					setFieldError({[inputField.key]: 'Product Name Should have Atleast 3 or More Characters'});
					isValid = false;
			   }
			}
		}
		return isValid;
	}
	
	const onAddEditModalBtnClick = () => {
		 if(validateInput()){
			 props.onModalClose();
			 props.onAddEditModalBtnClick(inputObj);
			 historyHandler.closeCurrent();
		 } 
	};

	  return(

            <EditProductModal
				title = {props.title}
                subTitle = {props.subTitle}
                buttonLabel = {props.buttonLabel}
				onAddEditModalBtnClick={onAddEditModalBtnClick}
				inputObj = {inputObj}
                onModalClose = {onModalClose}
                showLoader = {props.showLoader}
         />
    );
};


export default withPortal(EditProductModalWrapper, null, 'edit-product-modal');
